export const TYPESENSE_ANY = 'ANY';
export const TYPESENSE_COLLECTION_PRODUCTS = 'products';
export const TYPESENSE_COLLECTION_CATEGORIES = 'categories';
